import React from "react";

const FingerprintIcon = ({ color = "var(--color-latex30)", width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11C11.45 11 11 11.45 11 12C11 12.55 11.45 13 12 13C12.55 13 13 12.55 13 12C13 11.45 12.55 11 12 11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill={color}
      />
      <path
        d="M7.05 9.05C7.05 9.05 7.05 9.05 7.05 9.05C7.05 9.05 7.05 9.05 7.05 9.05C7.05 9.05 7.05 9.05 7.05 9.05Z"
        fill={color}
      />
      <path
        d="M12 6.5C9.24 6.5 7 8.74 7 11.5V15.5C7 16.05 7.45 16.5 8 16.5C8.55 16.5 9 16.05 9 15.5V11.5C9 9.84 10.34 8.5 12 8.5C13.66 8.5 15 9.84 15 11.5V15.5C15 16.05 15.45 16.5 16 16.5C16.55 16.5 17 16.05 17 15.5V11.5C17 8.74 14.76 6.5 12 6.5Z"
        fill={color}
      />
    </svg>
  );
};

export default FingerprintIcon;

